import axios from 'axios'
// const debug = process.env.NODE_ENV !== 'production'
const request = axios.create({
    // baseURL: 'http://cashcowerp.com:9217',  //测试
    // baseURL: 'http://192.168.0.107:9217',    //刘志杰
    baseURL:  'https://yinshitech.cn/api',  //正式
    withCredentials: false, // 表示跨域请求时是否需要使用凭证
    timeout: 10000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
})
export async function getListEthnic(){  //民族信息清单
    const resp = await request.get('/admin/ethnic/listEthnic');
    return resp.data;
}
export async function getListDocType(){  //证件类型
    const resp = await request.get('/admin/docType/listDocType');
    return resp.data;
}
export async function setSaveJobSeeker(data){  //保存求职者信息
    const resp = await request.post('/admin/jobSeeker/saveJobSeeker',data,{headers: {'Content-Type': 'multipart/form-data'}});
    return resp.data;
}
export async function setSaveContactUs(data){  //保存联系我们信息
    const resp = await request.post('/admin/contactUs/saveContactUs',data,{headers: {'Content-Type': 'application/json'}});
    return resp.data;
}
export async function getListNews(data){  //查询全部新闻动态信息
    const resp = await request.get('/admin/news/listNews?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function getListJoinUs(data){  //查询全部招聘信息
    const resp = await request.get('/admin/joinUs/listJoinUs?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function getListEducationals(){  //查询学历
    const resp = await request.get('/admin/educationals/listEducationals');
    return resp.data;
}
export async function getCompanyInfo(){  //查询公司信息
    const resp = await request.get('/admin/companyInfo/list');
    return resp.data;
}
export async function getListDownloadCenters(data){  //查询下载中心信息
    const resp = await request.get('/admin/downloadCenters/listDownloadCenters?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function  updateDownloadS(id) {    //递增下载中心下载量
    const resp = await request.put('/admin/downloadCenters/incrementalDownTimes?id='+id);
    return resp.data;
}
export async function  incrementalViews(id) {    //修改新闻动态浏览量
    const resp = await request.put('/admin/news/incrementalViews?id='+id);
    return resp.data;
}
export async function  getNews(id) {    //根据ID查询新闻动态信息
    const resp = await request.get('/admin/news/getNews?id='+id);
    return resp.data;
}
export async function listFaq(data){  //查询常见问题
    const resp = await request.get('/admin/faq/listFaq?page='+data.page+'&pageSize='+data.pageSize);
    return resp.data;
}
export async function listEnableSwiperInfo(){  //查询启用轮播图信息
    const resp = await request.get('/admin/swiperInfo/listEnableSwiperInfo');
    return resp.data;
}
export async function  getJoinUs(id) {    //查询单个招聘信息
    const resp = await request.get('/admin/joinUs/getJoinUs?id='+id);
    return resp.data;
}